import { Button, ButtonGroup, Tooltip } from "@material-ui/core";
import {
	Document,
	Image,
	Page,
	PDFDownloadLink,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";
import { useContext } from "react";
import { CSVLink } from "react-csv";
import ReactExport from "react-export-excel";
import AuthContext from "../../../context/Auth/authContext";

const DataExport = ({
	headers,
	datas,
	orientation,
	pageSize,
	fontSize,
	filename,
}) => {
	const authContext = useContext(AuthContext);
	const { stateLogoImages } = authContext;

	console.log("filename", filename);
	console.log("datas", datas || "");

	const ExcelFile = ReactExport.ExcelFile;
	const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
	const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

	const styles = StyleSheet.create({
		h1: {
			textAlign: "center",
			// marginTop: 20,
			marginBottom: 10,
			fontSize: 20,
			fontWeight: "bold",
		},
		subtitle: {
			textAlign: "center",
			// marginTop: 20,
			marginBottom: 10,
			fontSize: 13,
		},
		table: {
			flexDirection: "row",
			margin: 5,

			// display: "table-cell",
			// flexWrap: "nowrap",
			border: "2px solid white",
			fontSize,
			alignContent: "center",
			alignItems: "center",

			// flexWrap: "nowrap",
			// whiteSpace: "nowrap",
			// width: "100%",
		},
		tableCol: {
			flexDirection: "column",
			// flexWrap: "wrap",
			// flexDirection: "row",
			width: "100%",
			height: "100%",
		},
		row: {
			backgroundColor: "black",
			padding: 15,
			alignItems: "center",
			textAlign: "center",
			flexWrap: "wrap",
		},
		col: {
			height: "100%",
			textAlign: "center",
			flexWrap: "nowrap",
			whiteSpace: "wrap",
			textOverflow: "ellipsis",

			// padding: 5,
			// textOverflow: "ellipsis",
			// whiteSpace: "wrap",
			// overflow: "hidden",
			// display: "block",
			// minWidth: "1px",
		},
		text: {
			fontSize: 10,
			textAlign: "center",
		},
		headerText: {
			color: "white",
			fontStyle: "bold",
		},

		logo: {
			width: "10%",
			height: "10%",
			padding: 5,
			margin: "10px",
		},
		Tanggal: {
			margin: "auto 0 20px 20px",
			marginBottom: 10,
			fontSize: 14,
		},
	});

	const PDFDoc = (
		<Document>
			<Page size={pageSize} orientation={orientation}>
				<Image src={stateLogoImages?.path_logo} style={styles.logo} />
				<Text style={styles.h1}>
					Nama Aplikasi : {stateLogoImages?.nama_aplikasi}
				</Text>
				<Text style={styles.h1}>Lokasi : {stateLogoImages?.lokasi}</Text>
				<View style={styles.subtitle}>
					<Text>
						{filename.split("_").map((item, i) => {
							let name = "";
							return (name += item + " ");
						})}
					</Text>
				</View>
				<View style={styles.table}>
					{headers &&
						headers.map((el, i) => (
							<View key={i} style={styles.tableCol}>
								<View style={styles.row}>
									<Text style={styles.headerText}>{el.label}</Text>
								</View>
								{datas &&
									datas.map((d, index) => (
										<View
											key={index}
											style={{
												...styles.col,
												backgroundColor: index % 2 ? "#C9C9C9" : "#E8E8E8",
											}}
										>
											<Text style={styles.text}>
												{el.key === "idticket"
													? d.idticket.split("-").join("- ")
													: d[el.key]}
											</Text>
										</View>
									))}
							</View>
						))}
				</View>
			</Page>
		</Document>
	);

	return (
		<>
			{datas ? (
				<ButtonGroup
					color="primary"
					variant="outlined"
					aria-label="outlined primary button group"
					style={{ paddingRight: 15 }}
				>
					<Tooltip title="Export to (.csv)">
						<CSVLink
							data={datas}
							headers={headers}
							filename={filename + ".csv"}
						>
							<Button>CSV</Button>
						</CSVLink>
					</Tooltip>
					<ExcelFile
						element={
							<Tooltip title="Export to (.xlsx)">
								<Button>XLSX</Button>
							</Tooltip>
						}
						filename={filename}
					>
						<ExcelSheet data={datas} name={filename}>
							{datas &&
								headers.map((item, i) => (
									<ExcelColumn key={i} label={item.label} value={item.key} />
								))}
						</ExcelSheet>
					</ExcelFile>
					<PDFDownloadLink document={PDFDoc} fileName={filename + `.pdf`}>
						<Tooltip title="Export to (.pdf)">
							<Button>PDF</Button>
						</Tooltip>
					</PDFDownloadLink>
				</ButtonGroup>
			) : (
				<p style={{ paddingLeft: 15, color: "grey", fontSize: 12 }}>
					*Select Data to Export
				</p>
			)}
		</>
	);
};

export default DataExport;
